import { render, staticRenderFns } from "./bindCustomer.vue?vue&type=template&id=666230b2&scoped=true"
import script from "./bindCustomer.vue?vue&type=script&lang=js"
export * from "./bindCustomer.vue?vue&type=script&lang=js"
import style0 from "./bindCustomer.vue?vue&type=style&index=0&id=666230b2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666230b2",
  null
  
)

export default component.exports